import { render, staticRenderFns } from "./yearpicker-field.vue?vue&type=template&id=4f88f449&scoped=true&"
import script from "./yearpicker-field.vue?vue&type=script&lang=ts&"
export * from "./yearpicker-field.vue?vue&type=script&lang=ts&"
import style0 from "./yearpicker-field.vue?vue&type=style&index=0&id=4f88f449&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f88f449",
  null
  
)

export default component.exports